import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import { InitDetailInbound } from '@root/state/reducers/inboundReducer/inboundReducers';
import { Col, Row } from 'antd';
import CheckPoint from '../../Shared/Common/CheckPoint';
import CustomersAttachment from '../../Shared/Common/CustomersAttachment';
import DetailsProductForm from '../../Shared/Form/DetailsProductForm';
import ShipmentMethodForm from '../../Shared/Form/ShipmentMethod';
import ShippingPlantForm from '../../Shared/Form/ShippingPlantForm';
import CommentTabsComponent from '@core/components/CommentTabs';
import {
  CommentGroup,
  CommentList,
  CommentTabs,
  CommentType,
  CreateComment
} from '@core/components/CommentTabs/interface';
import commentService from '@core/components/CommentTabs/commentService';
import { useEffect, useState } from 'react';

interface DetailInboundProps {
  canEdit: boolean;
  setCanEdit: (canEdit: boolean) => void;
  setCommentAllId: (commentId: number) => void;
}
const DetailInbound = ({canEdit, setCanEdit, setCommentAllId}: DetailInboundProps) => {
  const { data } = useTypedSelector<InitDetailInbound>(
    (state) => state.detailInboundReducer
  );
  const [commentList, setCommentList] = useState<CommentList>();
  const [tabs, setTabs] = useState<any>([]);

  useEffect(() => {
    switch (data?.data?.status) {
      case 'Approved':
        setTabs([
          {
            title: 'Comment',
            type: CommentType.COMMON,
            description: 'Comment from Warehouse :'
          }
        ]);
        break;
      case 'Delivered':
        setTabs([
          {
            title: 'Comment',
            type: CommentType.COMMON,
            description: 'Comment from Warehouse :'
          },
          {
            title: 'Request modify',
            description: 'Reasons for modification from Warehouse :',
            type: CommentType.REQUEST_MODIFY,
            options: []
          }
        ]);
        break;
      default:
        setTabs([]);
        break;
    }
  }, [data]);

  const onSendComment = async (body: CreateComment, id?: number) => {
    if (id) {
      await commentService.updateComment(id, body);
    } else {
      await commentService.sendComment(body);
    }
    await getCommentList();
  };

  const getCommentList = async (showLoading?: Boolean) => {
    if (showLoading) {
    }
    const comments = await commentService.getComments({
      group: CommentGroup.INBOUND_DETAIL,
      itemId: data.data.id
    });
    setCommentList(comments);
    if (showLoading) {
    }
  };

  useEffect(() => {
    if (data.data && data.data.id) {
      getCommentList();
    }
  }, [data, canEdit]);

  return (
    <>
      <DetailsProductForm data={data?.data?.products} />
      <div
        style={{
          display: 'flex',
          marginTop: '15px',
          marginBottom: '20px'
        }}
      >
        <div style={{ width: '67%', display: 'flex', gap: '10px' }}></div>
      </div>
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col className="gutter-row" span={8} style={{ marginLeft: '10px' }}>
          <div className="shipmentMethod">
            <ShipmentMethodForm data={data.data} />
          </div>
        </Col>
        <Col className="gutter-row" span={8}>
          <div className="shippingPlan">
            <ShippingPlantForm data={data.data} />
          </div>
        </Col>
        <Col className="gutter-row" span={7}>
          <div className="checkPoint">
            <CheckPoint data={data.data} />
          </div>
        </Col>
      </Row>
      <CustomersAttachment />
      {data.data && data.data.id && (
        <CommentTabsComponent
          onSend={onSendComment}
          tabs={tabs}
          commentList={commentList!}
          refectComments={getCommentList}
          itemId={data.data.id}
          commentGroup={CommentGroup.INBOUND_DETAIL}
          updateItem={(commentId: number) => {
            setCommentAllId(commentId);
            setCanEdit(true);
          }}
        />
      )}
    </>
  );
}

export default DetailInbound;
